<template>
  <div id="app" :class="platformType" :style="{'--primaryColor': primaryColor, '--lightColor': lightColor}">
    <router-view/>
  </div>
</template>

<script>
import deviceUtils from './util/deviceUtils'
import {mapActions} from 'vuex'
import {on} from 'element-ui/lib/utils/dom'
import browserUtils from './util/browserUtils'

export default {
  name: 'App',
  data () {
    return {
      primaryColor: '',
      lightColor: ''
    }
  },
  computed: {
    platformType: function () {
      return 'platform-' + deviceUtils.getDeviceType().toLowerCase()
    }
  },
  methods: {
    ...mapActions(['loadUserAuthorize']),
    querySchoolName () {
      this.$ajax({
        url: '/index/baseSchool/getSchoolName',
        methods: 'post'
      }).then(response => {
        if (response.data) {
          if (response.data['responseCode'] === 'SUCCESS') {
            document.title = response.data['schoolName'] + ' -- 研究生招生报名系统管理后台'
            this.primaryColor = response.data['primaryColor']
            this.lightColor = response.data['lightColor']
            this.$store.commit('getSchoolInfo', {schoolName: response.data['schoolName']})
          }
        }
      })
    }
  },
  created () {
    this.loadUserAuthorize().then(result => {}, () => {})
  },
  mounted () {
    /* ie下部分路由不跳转修复 */
    if (browserUtils.isIE()) {
      on(window, 'hashchange', () => {
        let currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.replace(currentPath)
        }
      })
    }
    this.querySchoolName()
  }
}
</script>

<style lang="scss">
  /* 引入样式 */
  @import "styles/index";

  #app {
    width: 100%;
    height: 100%;
    @include execute(var(--primaryColor), var(--lightColor))
  }
</style>



// WEBPACK FOOTER //
// src/App.vue